import Vue from "vue";

Vue.filter("status", (str) => {
    switch (str) {
        case 10:
            return "مدخل";
        case 1:
            return "مفعل";
        case 2:
            return "مجمد";
        case 4:
            return "مرفوض";
        case 5:
            return "معتمد";
        case 8:
            return "مستخدم";
        case 11:
            return "منتهي";
        case 15:
            return "ارجاع ";

     case 16:
            return "تم الرد";



    }
});
Vue.filter("promotionsStatus", (str) => {
    switch (str) {
        case 10:
            return "مدخل";
        case 1:
            return "معتمد";
        case 12:
            return "غير مستكمل";      
           
    }
});
Vue.filter("discountType", (str) => {
    switch (str) {
        case 1:
            return "قيمة";
        case 2:
            return "نسبة";       
    }
    return "-"
});
Vue.filter("paymentStatus", (str) => {
    switch (str) {
        // case 10:
        //     return "مدخل";
        case 1:
            return "مدفوع";
        case 12:
            return "غير مستكمل";
            case 15:
                return "ارجاع ";
    }
});
Vue.filter("operationStatus", (str) => {
    switch (str) {
        case 10:
            return "مدخل";
        case 1:
            return "معتمد";
        case 4:
            return "مرفوض";
        case 12:
            return "غير مستكمل";
            case 15:
                return "ملغي ";
    }
});
Vue.filter("appointmentsStatus", (str) => {
    switch (str) {
        case 10:
            return " مبدائي";
        case 1:
            return " مؤكد";
        case 4:
            return "ملغي";
             case 5:
            return "تم الحضور";
        case 12:
            return "غير مدغوع"; 
             case 7:
            return "مراجعة";
    }
});
Vue.filter("employeeStatus", (str) => {
    switch (str) {
        case 1:
            return "موظف دائم";
        case 2:
            return "متوفى";
        case 3:
            return "مُستقيل ";
        case 4:
            return " مَقال ";
        case 6:
            return " متقاعد ";
    }
});

Vue.filter("gender", (str) => {
    switch (str) {
        case 1:
            return "ذكر";
        case 2:
            return "انثي ";
    }
});
Vue.filter("dayOfWeek", (str) => {
    switch (str) {
        case 0:
            return "الاحد";
        case 1:
            return "الاثنين";
        case 2:
            return "الثلاثاء";
        case 3:
            return "الاربعاء";
        case 4:
            return "الخميس";
        case 5:
            return "الجمعة";
        case 6:
            return "السبت";
    }
});

Vue.filter("userTypes", (str) => {
    switch (str) {
        case 1001:
            return "إداري";
        case 1003:
            return " مدير قسم";
        case 1002:
            return "مستخدم الموارد البشرية";
    }
});



Vue.filter("null", (str) => {
    if (str === "" || str === null) return "لا يوجد";
    else return str;
});

Vue.filter("requsetType", (str) => {
    if (str == true) return "الموظف";
    else return "الشؤون الإدارية والخدمات";
});
Vue.filter("IsMorning", (str) => {
    if (str == true) return "صباحاً";
    else return "مساءاً";
});

Vue.filter("empty", (str) => {
    if (str === "" || str === null) return "-";
    else return str;
});
Vue.filter("remainingAmout", (value, arg) => {
    const date1 = new Date(value);
    const date2 = new Date();
    var retirementAge = arg == 1 ? 65 : 60;

    const differenceInDays = Math.floor((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24));
    var age = Math.floor(differenceInDays / 365)
    var amount = (retirementAge - age) + age;
    date1.setDate(date1.getDate() + 1);

    return new Date(date1.setFullYear(date1.getFullYear() + amount)).toISOString().slice(0, 10).split('-').reverse().join('/');

});
Vue.filter("age", (value) => {
    const date1 = new Date(value);
    const date2 = new Date();

    const differenceInDays = Math.floor((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24));
    return Math.floor(differenceInDays / 365);

});